import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import KolMyGlassLogo from './KolMyGlassLogo';

/** Sticky header for marketing pages: transparent at top, same frosted bar as the homepage after scroll. */
export default function MarketingPublicNav() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`sticky top-0 z-50 py-5 transition-all duration-300 ${
        isScrolled ? 'border-b border-white/10 bg-[#0a0a0f]/90 backdrop-blur-xl' : ''
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6">
        <Link
          to="/"
          className="flex shrink-0 items-center outline-none ring-offset-2 ring-offset-[#0a0a0f] focus-visible:ring-2 focus-visible:ring-violet-500/80"
        >
          <KolMyGlassLogo variant="nav" forDarkBackground />
        </Link>
        <div className="flex items-center gap-4">
          <Link
            to="/login"
            className="rounded-lg bg-gradient-to-r from-violet-600 to-blue-500 px-5 py-2.5 text-sm font-semibold shadow-lg shadow-violet-500/20 transition-opacity hover:opacity-90"
          >
            Get Started
          </Link>
        </div>
      </div>
    </nav>
  );
}
